import { createRouter, createWebHashHistory } from 'vue-router'
import IndexPage from '@/views/IndexPage.vue'
import OrderQueryPage from '@/views/OrderQueryPage.vue'
import DownPage from '@/views/DownPage.vue'
import AboutPage from '@/views/AboutPage.vue'
import IDMPage from '@/views/IDMPage.vue'
import IDMPageV2 from '@/views/IDMPageV2.vue'
import FeedbackPage from '@/views/FeedbackPage.vue'
import VMwarePage from '@/views/VMwarePage.vue'
import BeyondComparePage from '@/views/BeyondComparePage.vue'
import FastCopyPage from '@/views/FastCopyPage.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: IndexPage
  },
  {
    path: '/:name', // 添加动态ID参数
    name: 'DownPage',
    component: DownPage,
    props: true // 启用props传递路由参数
  },
  {
    path: '/order-query',
    name: 'OrderQuery',
    component: OrderQueryPage
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage
  },
  {
    path: '/idm',
    name: 'IDM',
    component: IDMPage
  },
  {
    path: '/idmpro',
    name: 'IDM2',
    component: IDMPageV2
  },
  {
    path: '/vmware',
    name: 'VMware',
    component: VMwarePage
  },
  {
    path: '/beyond-compare',
    name: 'BeyondCompare',
    component: BeyondComparePage
  },
  {
    path: '/fastcopy',
    name: 'FastCopy',
    component: FastCopyPage
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: FeedbackPage
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router